/**
 * Created by DynamicDog on 2016-12-13.
 */
import {Component} from '@angular/core';
import {EtikettService} from "./services/etikett.service";
import { TranslateService } from './services/translate.service';

@Component({
    selector: 'app-footer',
    template: `
        <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
        <meta http-equiv="Pragma" content="no-cache">
        <meta http-equiv="Expires" content="0">
			<div class="content">
				<p id="intro-dansukker"><span [innerHTML]="translate.translate('intro-dansukker')"></span></p>
                <div style="display:block;font-weight:bold">{{'DELA MED DINA VÄNNER'|translate}}</div>
				<div class="addthis_toolbox addthis_default_style share-widgets" [attr.addthis:url]=path>
					<div class="custom_images">
  						<a class="addthis_button_facebook" onclick="return false"><img src="./css/images/round-facebook-icon.png" width="35" height="35" border="0"></a>
  						<a class="addthis_button_twitter" onclick="return false"><img src="./css/images/round-twitter-icon.png" width="35" height="35" border="0"></a>
  					</div>
				</div>
			
				<a href="{{'Sekretesspolicy-link'|translate}}">{{'Sekretesspolicy'|translate}}</a>
            </div>
        `
})
export class AppFooterComponent {
    private path:string;
    private encodedPath:string;
    constructor(private etikettService:EtikettService,private translate:TranslateService) {
        this.path = this.etikettService.host+this.etikettService.server+this.etikettService.aspxFile;
        this.encodedPath = encodeURIComponent(this.path);
    }

}


// WEBPACK FOOTER //
// ./app/appfooter.component.ts